import { CYCLE_ORDER, PHASE_META } from '@/lib/scoring';
import type { CyclePhase } from '@/lib/types';
import { cn } from '@/lib/utils';

export function CyclePhaseBar({ phase }: { phase: CyclePhase }) {
  const currentOrder = PHASE_META[phase].order;
  return (
    <div className="flex items-center gap-1">
      {CYCLE_ORDER.map((p, i) => {
        const active = i === currentOrder;
        const passed = i < currentOrder;
        return (
          <div key={p} className="flex flex-1 flex-col items-center gap-1.5">
            <div
              className={cn(
                'h-1.5 w-full rounded-full transition-colors',
                active
                  ? 'bg-primary shadow-[0_0_12px_hsl(145_63%_49%/0.6)]'
                  : passed
                    ? 'bg-primary/40'
                    : 'bg-border',
              )}
            />
            <span
              className={cn(
                'text-[9px] font-medium uppercase tracking-wider sm:text-[10px]',
                active ? 'text-primary' : 'text-muted-foreground',
              )}
            >
              {PHASE_META[p].label}
            </span>
          </div>
        );
      })}
    </div>
  );
}
